/**
 * @description
 * Format converter to 1920/1080 screen size
 */
export const SCREEN_ASPECT_CONVERTER: number = 1.78;
